import React, { useState } from 'react';
import { Nav, Row, Col, Tab } from 'react-bootstrap';
import styled from 'styled-components';
import { FaUsers } from 'react-icons/fa';
import { HiDocumentText } from 'react-icons/hi';
import { HDivider } from 'components/CommonWidgets';
import UsersTab from './users-tab';
import UserGroupsTab from './user-groups-tab';

const MainCard = styled.div`
	background-color: white;
	position: relative;
	border-radius: 26px;
	margin: 1rem 0 0 1rem;
`;

const TabsCard = styled.div`
	background-color: white;
	margin: 0 auto;
	border-radius: 26px;
`;

const TabColumn = styled(Col)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a {
        color: black;
        font-weight: 900;
        font-size: 14pt;
    }
`;

const TabLine = styled.div`
	width: 10em;
	height: 0.5rem;
	background-color: #0278ee;
	border-top-left-radius: 11px;
	border-top-right-radius: 11px;
`;

const TabContent = styled(Tab.Content)`
    width: 100%;
    margin: 2rem 0 3rem 0;
    transition: all 500ms ease-in-out;
`;

const PageTitle = styled.div`
	color: white;
	font-size: 18pt;
	font-weight: 700;
	text-align: end;
`;

const UsersManagement = () => {
	const [ currentTab, setCurrentTab ] = useState('users');

	return (
		<div>
			<Row className="mt-2">
				<PageTitle>مدیریت کاربران</PageTitle>
			</Row>
			<MainCard>
				<Tab.Container defaultActiveKey={currentTab} onSelect={(k) => setCurrentTab(k)}>
					<TabsCard className="pt-4">
						<Nav>
							<Row className="w-100">
								<TabColumn md={6}>
									<HiDocumentText size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'user-groups'}>مدیریت گروه های کاربری</Nav.Link>
									</Nav.Item>
									{currentTab === 'user-groups' && <TabLine />}
								</TabColumn>
								<TabColumn md={6}>
									<FaUsers size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'users'}>مدیریت کاربران</Nav.Link>
									</Nav.Item>
									{currentTab === 'users' && <TabLine />}
								</TabColumn>
							</Row>
							<HDivider />
						</Nav>
					</TabsCard>
					<Row>
						<TabContent>
							<Tab.Pane eventKey="users">
								<UsersTab currentTab={currentTab} />
							</Tab.Pane>
							<Tab.Pane eventKey="user-groups">
								<UserGroupsTab currentTab={currentTab} />
							</Tab.Pane>
						</TabContent>
					</Row>
				</Tab.Container>
			</MainCard>
		</div>
	);
};

export default UsersManagement;
